<template>
  <div class="col-12">
    <div class="container">

      <div class="form-group row">
        <label data-tour-step="4" class="col-form-label">
          Recipients
          <span class="text text-danger">*</span>
        </label>
        <div class="col-12" >
          <a-radio-group
            v-model="broadcastParam.is_group_type"
            @change="changeDestination"
          >
            <a-radio-button value="group">
              <i class="fa fa-users"></i>
              Group
            </a-radio-button>
            <a-radio-button value="tags">
              <i class="fa fa-tags"></i>
              Tags
            </a-radio-button>
            <a-radio-button value="">
              <i class="fa fa-user"></i>
              Contact
            </a-radio-button>
          </a-radio-group>
        </div>
        <div class="col-12 mt-4">
          <multiselect
            v-if="
              broadcastParam.is_group == 1 &&
              broadcastParam.is_group_type == 'group'
            "
            v-model="broadcastParam.to_group"
            id="ajax"
            label="name"
            track-by="id"
            placeholder="Ketik untuk mencari data..."
            open-direction="bottom"
            :custom-label="(val) => val.name"
            :options="contactOptionsGroup"
            :multiple="true"
            :searchable="true"
            :loading="isLoadingGroup"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="false"
            :options-limit="300"
            :limit="3"
            :limit-text="(count) => count + ' other'"
            :max-height="600"
            :show-no-results="true"
            :hide-selected="true"
            @open="asyncFindGroup('')"
            @search-change="asyncFindGroup"
            :show-labels="false"
          >
            <template slot="tag" slot-scope="{ option, remove }">
              <span class="custom__tag">
                <span>{{ option.name }}</span>
                <span class="custom__remove" @click="remove(option)">❌</span>
              </span>
            </template>
            <template slot="clear" slot-scope="props">
              <div
                class="multiselect__clear"
                v-if="broadcastParam.to_group.length"
                @mousedown.prevent.stop="broadcastParam.to_group = []"
              ></div>
            </template>
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
          <multiselect
            v-if="
              broadcastParam.is_group == 1 &&
              broadcastParam.is_group_type == 'tags'
            "
            v-model="broadcastParam.to_group"
            placeholder="Ketik untuk mencari data..."
            id="ajax"
            label="name"
            track-by="id"
            :multiple="true"
            :custom-label="(val) => val.name"
            :options="tagsOptions"
            :searchable="true"
            :loading="isLoading"
            :internal-search="false"
            :close-on-select="false"
            :options-limit="300"
            :limit="3"
            :limit-text="(count) => count + ' other'"
            :max-height="600"
            :show-no-results="true"
            @open="tagsAsyncFind('')"
            :hide-selected="true"
            @search-change="tagsAsyncFind"
          >
            <template slot="tag" slot-scope="{ option, remove }">
              <span class="custom__tag">
                <span>{{ option.name }}</span>
                <span class="custom__remove" @click="remove(option)">❌</span>
              </span>
            </template>
            <template slot="clear" slot-scope="props">
              <div
                class="multiselect__clear"
                v-if="broadcastParam.to_group.length"
                @mousedown.prevent.stop="broadcastParam.to_group = []"
              ></div>
            </template>
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
          <multiselect
            v-if="broadcastParam.is_group == 0"
            v-model="broadcastParam.to"
            id="ajax"
            label="first_name"
            track-by="phone_number"
            placeholder="Ketik untuk mencari data..."
            open-direction="bottom"
            :custom-label="
              ({ is_group, first_name, provider, phone_number }) => {
                if (is_group == 1) {
                  return `${first_name} – ${provider}`;
                } else {
                  return `${first_name} – ${phone_number}`;
                }
              }
            "
            :options="contactOptions"
            :multiple="true"
            :searchable="true"
            :loading="isLoading"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="false"
            :options-limit="300"
            @open="asyncFindContact('')"
            :limit="3"
            :limit-text="(count) => count + ' other'"
            :max-height="600"
            :show-no-results="true"
            :hide-selected="true"
            @search-change="asyncFindContact"
            :show-labels="false"
          >
            <template slot="tag" slot-scope="{ option, remove }">
              <span class="custom__tag">
                <span v-if="option.is_group == 1">{{
                  option.first_name + " (" + option.provider + ")"
                }}</span>
                <span v-else>{{
                  option.first_name + " (" + option.phone_number + ")"
                }}</span>
                <span class="custom__remove" @click="remove(option)">❌</span>
              </span>
            </template>
            <template slot="clear" slot-scope="props">
              <div
                class="multiselect__clear"
                v-if="broadcastParam.to.length"
                @mousedown.prevent.stop="broadcastParam.to = []"
              ></div>
            </template>
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <div class="text-right">
            <button
              @click="cancelForm"
              class="btn btn-md btn-warning"
              type="button"
            >
              <i class="fa fa-close"></i> Cancel
            </button>
            <button
              @click="update"
              class="btn btn-md btn-success"
              type="button"
            >
              <i class="fa fa-check"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "form1",
  components: {
    Multiselect,
  },
  computed: {
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
    broadcastStep: {
      get() {
        return this.$store.state.omniwa.broadcastStep;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastStep", val);
      },
    },
  },
  watch: {
    broadcastStep(val) {
      if (val == "1") {
        this.broadcastParam = structuredClone(this.broadcastParamSt);
      }
    },
  },
  mounted() {
    this.broadcastParam = structuredClone(this.broadcastParamSt);
  },
  data() {
    return {
      // Default aman agar render pertama tidak mengakses null.
      // Nilai ini akan diganti dengan clone dari store pada mounted().
      broadcastParam: {
        is_group: 1,
        is_group_type: "group",
        to: [],
        to_group: [],
      },
      selectedContactGroup: [],
      selectedContact: [],
      selectedTags: [],
      contactOptionsGroup: [],
      contactOptions: [],
      tagsOptions: [],
      isLoadingGroup: false,
      isLoading: false,
      isLoadingTags: false,
    };
  },
  methods: {
    changeDestination() {
      if (this.broadcastParam.is_group_type == "") {
        this.broadcastParam.is_group = 0;
      } else {
        this.broadcastParam.is_group = 1;
      }
      setTimeout(() => {
        console.log("reset");
        this.$nextTick(() => {
          this.broadcastParam.to = [];
          this.broadcastParam.to_group = [];
        });
      }, 300);
    },
    update() {
      this.broadcastParamSt = structuredClone(this.broadcastParam);
      this.broadcastStep = "";
    },
    asyncFindGroup(query) {
      // console.log("query", query);
      let serverParams = {
        name: query,
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0,
      };
      this.isLoadingGroup = true;
      this.$store
        .dispatch("contact/getGroupList", serverParams)
        .then((response) => {
          this.isLoadingGroup = false;
          this.contactOptionsGroup = response.data.map((i) => {
            return {
              ...i,
              is_group: 1,
            };
          });
          // console.log("query: ", query);
          // console.log("contactOptionsGroup: ", this.contactOptionsGroup);
        }) // sesuai kan dengan method di API
        .catch((error) => {
          this.isLoadingGroup = false;
        });
    },
    tagsAsyncFind(query) {
      this.isLoading = true;
      let serverParams = {
        name: query,
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0,
      };
      this.$store
        .dispatch("crm/listTagsBC", serverParams)
        .then((response) => {
          this.isLoading = false;
          this.tagsOptions = response.data.data.map((i) => {
            return {
              ...i,
              is_group: 1,
            };
          });
        }) // sesuai kan dengan method di API
        .catch((error) => {
          this.isLoading = false;
        });
    },
    cancelForm() {
      this.$fire({
        title: "Are you sure?",
        text: "Your progress will not be saved.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.value) {
          this.goBack();
        }
      });
    },
    goBack() {
      this.$store.commit("omniwa/SET_broadcastStep", "");
    },
    asyncFindContact(query) {
      this.isLoading = true;
      let serverParams = {
        keywords: query,
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0,
      };
      this.$store
        .dispatch("contact/getContactList", serverParams)
        .then((response) => {
          this.isLoading = false;
          this.contactOptions = response.data.map((i) => {
            return {
              ...i,
              is_group: 0,
            };
          });
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.cont  actOptions);
        }) // sesuai kan dengan method di API
        .catch((error) => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/form1.vue